import { Component } from '@angular/core';
import { IonicPage, ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import { DailyLogOperationInstance, LogComment } from '../../../models/projects/operation.models';
import { OperationService } from '../../../services/operations/operation/operation.service';
import { cloneDeep } from 'lodash';
import { NavHelperService } from '../../../services/nav/nav-helper.service';
import { LockedDayPermissions } from '../../../models/permissions/permission.models';
import { AppConfig } from '../../../app/app.config';
import { DailyLogModalPage } from '../../daily-log/daily-log-modal/daily-log-modal';
import { SupportContextKey } from '../../../models/support/support.models';
import { SupportContextService } from '../../../services/support/support-context.service';

@IonicPage()
@Component({
  selector: 'page-operation-comments',
  templateUrl: 'operation-comments.html',
})

export class OperationCommentsPage {
  config = AppConfig.settings;
  tempComment: LogComment;
  originalComment: LogComment;
  operationInstance: DailyLogOperationInstance = new DailyLogOperationInstance();
  isStart: boolean;
  loading: boolean = true;
  lockedDayPermissions: LockedDayPermissions;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public operationService: OperationService,
              public navHelperService: NavHelperService,
              private toastCtrl: ToastController,
              private modalController: ModalController,
              private supportContextService: SupportContextService
  ) {
    this.operationInstance = navParams.get('operationInstance');
    this.isStart = navParams.get('isStart');
    this.lockedDayPermissions = navParams.get('lockedDayPermissions');
    this.tempComment = this.isStart ? cloneDeep(this.operationInstance.startComment) : cloneDeep(this.operationInstance.endComment);
    this.originalComment = this.tempComment ? cloneDeep(this.tempComment) : {data: '', milestone: false};
  }

  ionViewDidEnter() {
    this.supportContextService.setComponentContext(
      SupportContextKey.EditOperation,
      'Operation Comments',
      'OperationCommentsPage',
      this.getOperationSupportDetails()
    );

    this.navHelperService.commentWarned = false;
    this.navHelperService.showCommentWarning = false;
    this.loading = false;
  }

  ionViewCanLeave(): boolean {
    if (this.navHelperService.unsavedComment && !this.navHelperService.commentWarned) {
      this.navHelperService.commentWarned = true;
      this.navHelperService.showCommentWarning = true;
      this.navHelperService.unsavedComment = false;
      return false;
    }
    return true;
  }

  commentChanged(comment: LogComment) {
    this.tempComment = comment;
    if (this.originalComment.data !== this.tempComment.data
      || this.originalComment.appear !== this.tempComment.appear
      || this.originalComment.milestone !== this.tempComment.milestone) {
      this.navHelperService.unsavedComment = true;
    } else {
      this.navHelperService.unsavedComment = false;
    }
  }

  save() {
    if (this.isStart) {
      this.operationInstance.startComment = this.tempComment;
    } else {
      this.operationInstance.endComment = this.tempComment;
    }

    this.navHelperService.unsavedComment = false;

    this.presentSaveToast().then(() => {
      this.navCtrl.pop();
    });
  }

  presentSaveToast(): Promise<any> {
    const toast = this.toastCtrl.create({
      message: 'Comment Saved',
      duration: 3000,
      position: 'bottom'
    });

    return toast.present();
  }

  openDailyLogModal() {
    const dailyLogModal = this.modalController.create(DailyLogModalPage);
    dailyLogModal.present();
  }

  private getOperationSupportDetails(): {[key: string]: string} {
    return {
      instanceId: this.getOperationInstanceId(),
      operationName: this.getOperationName()
    };
  }

  private getOperationInstanceId(): string {
    if (!this.operationInstance) {
      return '';
    }

    return this.operationInstance.id != null
      ? `${this.operationInstance.id}`
      : this.operationInstance.localId != null
        ? `${this.operationInstance.localId}`
        : '';
  }

  private getOperationName(): string {
    if (!this.operationInstance || !this.operationInstance.projectSpecificOperation) {
      return '';
    }

    return this.operationInstance.projectSpecificOperation.name
      || this.operationInstance.projectSpecificOperation.operationSummary?.name
      || '';
  }
}



// WEBPACK FOOTER //
// ./src/pages/operations/operation-comments/operation-comments.ts